<template lang="pug">
aside-modal(:id="modalId", width="w-xtra-large", :loading="onLoading('save-modifier-sets')")
    span(slot="header-text") {{ modifierExists ? 'Update' : 'Create' }} Modifier Set
    div(slot="body")
        div.container
            form(id="modifierSetFnbForm")
                fieldset
                    div.row
                        div.col-md-12.p-l-md.p-t-md.p-r-md
                            div.row
                                div.col-md-12
                                    h6.m-b-md Details

                                    div.row
                                        div.col-md-12
                                            div.md-form-group
                                                input.md-input(
                                                    placeholder="e.g Addons, Add Topping",
                                                    type="text",
                                                    :value="modifierSet.name",
                                                    @input="updateModiferSet('name', $event)",
                                                    required
                                                )
                                                label Name

                                        div.col-md-12
                                            p Selection Mode

                                        div.col-xs-6
                                            div.md-form-group
                                                input.md-input(
                                                    type="number",
                                                    required,
                                                    v-model="modifierSet.min_apply_limit",
                                                    @input="updateModiferSet('min_apply_limit', $event)"
                                                    v-validate="'numeric|max_value:'+modifierSet.max_apply_limit",
                                                    name="Min Apply"
                                                )
                                                label Min Apply Limit
                                                span.text-danger(v-if="errors.has('Min Apply')")
                                                            | {{ errors.first('Min Apply') }}

                                        div.col-xs-6
                                            div.md-form-group
                                                input.md-input(
                                                    type="number",
                                                    required,
                                                    v-model="modifierSet.max_apply_limit",
                                                    @input="updateModiferSet('max_apply_limit', $event)"
                                                    v-validate="'numeric|min_value:'+this.getMinValue(modifierSet.min_apply_limit)"
                                                    name="Max Apply"
                                                )
                                                label Max Apply Limit
                                                span.text-danger(v-if="errors.has('Max Apply')")
                                                            | {{ errors.first('Max Apply') }}

                                        div.col-md-12
                                            div.md-form-group.p-t-0
                                                label.multiselect-label Products
                                                multiselect(
                                                    v-model="modifierSet.products",
                                                    label="name",
                                                    track-by="id",
                                                    placeholder="Type to search",
                                                    :options="products",
                                                    :multiple="true",
                                                    :loading="ajaxProductLoading",
                                                    :close-on-select="false",
                                                    :limit="20",
                                                    @search-change="loadProducts"
                                                )

                                            p Modifiers

                                        div.col-md-12
                                            draggable(
                                                v-model="modifiers",
                                                :options="{handle: '.drag-handler'}"
                                            )
                                                div.modifiers-input-list(
                                                    v-for="(modifier, idx) in modifierSet.modifiers",
                                                    :key="idx"
                                                )
                                                    div.row
                                                        div.col-xs-12.modifiers(
                                                            :class="{ 'p-l-lg': hasMultipleModifier }"
                                                        )
                                                            i.fa.fa-bars.drag-handler.text-muted.m-t-xs(
                                                                v-show="hasMultipleModifier"
                                                            )

                                                            div.col-xs-1
                                                                label.md-label Preselect
                                                                p.p-t-md
                                                                    label.md-check
                                                                        input.has-value(
                                                                            type="checkbox",
                                                                            name="preselected",
                                                                            :disabled="disablePreselect",
                                                                            :checked="modifier.pre_selected == true",
                                                                            @change="updateModiferSet('modifiers', $event, 'pre_selected', idx)"
                                                                        )
                                                                        i.indigo

                                                            div.col-xs-4.p-l-md
                                                                div.md-form-group
                                                                    select.md-input(
                                                                        required,
                                                                        :value="modifier.mode",
                                                                        @input="updateModiferSet('modifiers', $event, 'mode', idx)"
                                                                    )
                                                                        option(v-for="mode in modes" v-bind:value="mode.id")
                                                                            | {{ mode.name }}
                                                                    label Mode

                                                            div.col-xs-3
                                                                div.md-form-group
                                                                    input.md-input(
                                                                        type="text",
                                                                        :value="modifier.name",
                                                                        required,
                                                                        placeholder="e.g Extra Cheese",
                                                                        @input="updateModiferSet('modifiers', $event, 'name', idx)"
                                                                    )
                                                                    label Name

                                                            div.col-xs-3
                                                                div.md-form-group(:class="{'invalid': hasModifierAmountError(idx)}")
                                                                    input.md-input(
                                                                        v-show="modifier.mode != 0",
                                                                        type="text",
                                                                        :value="modifier.amount",
                                                                        required,
                                                                        min="0",
                                                                        placeholder="0.00",
                                                                        data-parsley-type="number",
                                                                        data-parsley-min="0",
                                                                        data-parsley-min-message="This value should be greater than or equal to 0.",
                                                                        data-parsley-errors-messages-disabled="",
                                                                        @input="updateModiferSet('modifiers', $event, 'amount', idx); validateModifierAmount($event.target.value, idx)",
                                                                        :class="{'parsley-error': hasModifierAmountError(idx)}"
                                                                    )
                                                                    span.clear.p-t-sm.text-muted(v-show="modifier.mode == 0") N/A
                                                                    label(
                                                                        v-if="modifier.mode == 1 || modifier.mode == 2",
                                                                        :class="{'text-danger': hasModifierAmountError(idx)}"
                                                                    ) Amount (RM)
                                                                    label(
                                                                        v-else-if="modifier.mode == 3",
                                                                        :class="{'text-danger': hasModifierAmountError(idx)}"
                                                                    ) Amount (%)
                                                                    label(
                                                                        v-else,
                                                                        :class="{'text-danger': hasModifierAmountError(idx)}"
                                                                    ) Amount
                                                                    ul.parsley-errors-list(v-if="hasModifierAmountError(idx)")
                                                                        li.text-danger This value should be greater than or equal to 0.

                                                            div.col-xs-1(v-if="hasMultipleModifier")
                                                                i.text-muted.material-icons.md-18.btn-del-list.pointer(
                                                                    @click="removeModifier(idx)"
                                                                ) &#xe14c;

                                        div.col-xs-12
                                            button.btn.btn-outline.btn-sm.rounded.b-success.text-success.pull-right(
                                                type="button",
                                                @click="addModifier"
                                            )
                                                i.material-icons.md-18 &#xe145;
                                                | Add Modifiers`

                        //div.col-md-6.p-l-md.p-t-md.p-r-md
                        //    div.row
                        //        div.col-md-12
                        //            h6.m-b-md Recipe Details &nbsp;
                        //                label.md-switch(slot="popup")
                        //                    input(type='checkbox' v-model="toggleRecipe")
                        //                    i.indigo
                        //
                        //                p.text-muted.small Recipe details can support for topup and deduction mode. Please assign correct ingredients.
                        //
                        //            div(v-if="toggleRecipe")
                        //                div.p-t-sm
                        //                    div(v-for="modifier in modifiers")
                        //                        div(v-if="modifier.mode == 1 || modifier.mode == 2")
                        //                            span._500 {{ modifier.mode == 1 ? 'Topup' : 'Deduct' }} {{ modifier.name }}
                        //
                        //                            modifier-ingredient.m-t-1(
                        //                                :modifier="modifier"
                        //                                ref="modifierIngredient"
                        //                            )

    button.btn.btn-fw.primary(
        slot="footer",
        @click="submit()",
        :disabled="onLoading('save-modifier-sets') || !canManageItems"
    )
        v-loading(loader="save-modifier-sets") Save
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import draggable from 'vuedraggable';
import PermissionMixin from '../item-permission';
import modifierIngredient from './modifier-ingredient';

export default {
    components: {
        draggable,
        modifierIngredient,
    },

    mixins: [PermissionMixin],

    data() {
        return {
            ajaxProductLoading: false,
            apiProductSelect: Laroute.route('franchise.vue.products'),
            products: [],
            toggleRecipe: false,
            modifierAmountErrors: {},
        };
    },

    computed: {
        modalId() {
            return 'modifier-fnb-modal';
        },

        ...mapGetters('modifierSet', [
            'modifierSet',
            'modes',
            'hasMultipleModifier',
            'totalPreSelected',
            'getPreselectedModifiers',
            'modifierExists',
        ]),

        disablePreselect() {
            const maxApply = this.modifierSet.max_apply_limit;
            return (
                this.totalPreSelected >= maxApply &&
                maxApply != 0 &&
                maxApply !== null
            );
        },

        modifiers: {
            get() {
                return this.modifierSet.modifiers;
            },
            set(value) {
                console.log(value);
                this.setModifiers(value);
            },
        },
    },

    watch: {
        // remove preselected as it should respect max limit
        'modifierSet.max_apply_limit'(newVal, oldVal) {
            if (
                this.totalPreSelected > newVal &&
                newVal != 0 &&
                newVal !== null
            ) {
                let totalShouldRemove = this.totalPreSelected - newVal;
                let preselectedModifiers = this.getPreselectedModifiers;

                preselectedModifiers
                    .sort((a, b) => {
                        if (a.original_index > b.original_index) {
                            return -1;
                        }

                        if (a.original_index < b.original_index) {
                            return 1;
                        }

                        return 0;
                    })
                    .forEach((m, index) => {
                        if (index >= totalShouldRemove) {
                            return;
                        }

                        let input = {
                            attribute: 'modifiers',
                            value: false,
                            modifier_attr: 'pre_selected',
                            modifier_index: m.original_index,
                        };

                        this.setModifierSetAttribute(input);
                    });
            }
        },
    },

    created() {
        this.resetModifierSet();
        this.registerEventBus();
    },

    mounted() {
        this.loadProducts(null);
        this.errors.remove();
    },

    methods: {
        ...mapActions('modifierSet', [
            'setModifierSetAttribute',
            'addModifier',
            'removeModifier',
            'createModifierSet',
            'updateModifierSet',
            'addModifierSet',
            'resetModifierSet',
            'getModifierSet',
            'setModifiers',
        ]),

        loadProducts: _.debounce(function(query) {
            let options = {
                params: {
                    query: query,
                    limit: 30,
                },
            };

            this.ajaxProductLoading = true;
            this.$http.get(this.apiProductSelect, options).then(response => {
                this.products = response.data.data;
                this.ajaxProductLoading = false;
            });
        }, 500),

        async submit() {
            this.validateMinMax();

            if (this.errors.has('Min Apply') || this.errors.has('Max Apply'))
                return;

            // Validate all modifier amounts before parsley validation
            this.modifierSet.modifiers.forEach((modifier, idx) => {
                if (modifier.mode != 0) {
                    this.validateModifierAmount(modifier.amount, idx);
                }
            });

            // Check if any modifier has amount error
            const hasAmountError = Object.values(
                this.modifierAmountErrors,
            ).some(error => error === true);
            if (hasAmountError) {
                return;
            }

            if (!this.validateForm('modifierSetFnbForm')) return;
            let modifierValidation = false;

            if (this.toggleRecipe) {
                this.modifiers
                    .filter(m => {
                        return m.mode == 1 || m.mode == 2;
                    })
                    .map((m, index) => {
                        let v = this.$refs.modifierIngredient[index];
                        v.errors.clear();
                        v.validate();

                        if (v.hasValidationError) {
                            modifierValidation = true;
                        }
                    });
            }

            if (modifierValidation) {
                return;
            }

            const func = this.modifierExists
                ? 'updateModifierSet'
                : 'createModifierSet';

            this[func]()
                .then(res => {
                    if (!this.modifierExists) {
                        this.resetModifierSet();
                    } else {
                        this.hideModal();
                    }

                    this.showToastrSuccess();
                    this.$emit('modifiersetfnb-saved');
                })
                .catch(err => {
                    this.showApiError(err);
                });
        },

        showModal() {
            $(`#${this.modalId}`).modal('show');
        },

        hideModal() {
            $(`#${this.modalId}`).modal('hide');
        },

        updateModiferSet(
            attribute,
            event,
            modifier_attr = null,
            modifier_index = null,
        ) {
            let value;

            if (event.srcElement.type === 'checkbox') {
                value = event.target.checked;
            } else {
                value = event.target.value;
            }

            let input = {
                attribute,
                value,
                modifier_attr,
                modifier_index,
            };

            this.setModifierSetAttribute(input);

            // Clear error when modifier is removed
            if (
                attribute === 'modifiers' &&
                modifier_attr === 'amount' &&
                modifier_index !== null
            ) {
                // Error validation is handled in validateModifierAmount method
            }
        },

        getMinValue(value) {
            if (value == 0) {
                return 1;
            }
            return value;
        },
        validateMinMax() {
            if (this.modifierSet.max_apply_limit == 0) {
                this.errors.add({
                    field: 'Max Apply',
                    msg: `The Max Apply field must be 1 or more. `,
                });
            }
        },

        validateModifierAmount(value, idx) {
            const numValue = parseFloat(value);
            if (!isNaN(numValue) && numValue < 0) {
                this.$set(this.modifierAmountErrors, idx, true);
            } else {
                this.$set(this.modifierAmountErrors, idx, false);
            }
        },

        hasModifierAmountError(idx) {
            return this.modifierAmountErrors[idx] === true;
        },

        registerEventBus() {
            this.$on('show-form', modifierSet => {
                if (modifierSet === null) {
                    this.resetModifierSet();
                    this.showModal();
                } else {
                    this.getModifierSet(modifierSet.id)
                        .then(res => {
                            this.showModal();
                            if (res.data.data.toggleRecipe) {
                                this.toggleRecipe = res.data.data.toggleRecipe;
                            } else {
                                this.toggleRecipe = false;
                            }
                        })
                        .catch(err => this.showApiError(err));
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/modifier/vuetablemodifier_fnb_form.vue